import pick from 'lodash/pick';
import { ColorVariant } from './color-variant';
export const BlockSimpleColor = pick(ColorVariant, ['White', 'Gray', 'Blue']);
//# sourceMappingURL=block-simple-colors.js.map